// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"cb5e0c19","459":"049283fc","629":"e14ab185","715":"4dab2073","774":"c0a8a2f7","858":"72289d23","864":"8bcb356d","883":"4ebd21de"}[chunkId] + ".chunk.js";
};